export default {
  userName: null,
  soundFlag: false,
  isMovieActive: false,
  isAnimBg: false,
  bgNumber: 0
};
